import React from 'react';
import './SearchCounterBadge.css';

const SearchCounterBadge = ({ remainingSearches, requiresPayment, onPay }) => {
  if (requiresPayment) {
    return (
      <div className="search-counter-badge warning">
        <span className="badge-icon">⊙</span>
        <span className="badge-text">Porabili ste vsa iskanja</span>
        {onPay && (
          <button className="badge-pay-button" onClick={onPay}>Zakupi iskanja</button>
        )}
      </div>
    );
  }

  if (remainingSearches === null) return null;

  return (
    <div className={`search-counter-badge ${remainingSearches > 1 ? 'active' : 'warning'}`}>
      <span className="badge-icon">⊙</span>
      <span className="badge-text">
        Število iskanj na voljo: {remainingSearches}
      </span>
    </div>
  );
};

export default SearchCounterBadge;
